<div class="asset-form">
    <rl-multiple-file-input
        (uploadsStarted)="saveButton.disabled = true"
        [fileTypeCategories]="fileTypeCategories"
        (uploadedS3Keys)="onUploadedS3KeysChanged($event)"
        [confirmOnDelete]="true">
    </rl-multiple-file-input>
</div>
